import { QuestionType } from '../constants/common';

// Every field on the form regardless of page/section, used by GRID questions
// to resolve a cell's linkedFieldId to the actual field object anywhere on
// the form (grid cells link 1:1 to fields that live outside the grid itself).
export const flattenFormFields = (formdata) => {
  if (!formdata) return [];
  const result = [...(formdata.fields || [])];
  const walk = (sections) => {
    (sections || []).forEach((section) => {
      result.push(...(section.fields || []));
      walk(section.subSections);
    });
  };
  walk(formdata.sections);
  return result;
};

export const getInputTypeForFieldType = (fieldType) => {
  if (fieldType === QuestionType.NUMERIC_VALUE) return 'number';
  return 'text';
};

// A GRID question never owns an answer of its own — each cell's value is
// saved under its linked field's own responseData entry — so its (empty)
// responseData entry must be stripped out before submitting to the server.
export const excludeGridQuestionResponses = (responseData, formdata) => {
  const allFields = flattenFormFields(formdata);
  return (responseData || []).filter((r) => {
    const field = allFields.find((f) => f.id === r.formField?.id);
    return field?.type !== QuestionType.GRID;
  });
};
